<template>
  <div>
    <div class="handle-box">
      <el-button type="success" icon="el-icon-refresh" @click="resetDefault" plain>重置成默认规则</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="addRule">添加</el-button>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
      :cell-style="centerStyle">
      <el-table-column prop="ID" label="ID" width="55" align="center"></el-table-column>
      <el-table-column prop="name" label="等级名称" width="200" show-overflow-tooltip
        header-align="center"></el-table-column>
      <el-table-column prop="month" label="统计单位" width="200" show-overflow-tooltip header-align="center">
        <template #default="scope">
          <span>{{ monthMap.get(scope.row.month) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="minQuantity" label="单位内下单量" header-align="center" width="250">
        <template #default="scope">
          <span>{{ scope.row.minQuantity }}单 ~ {{ scope.row.maxQuantity }}单</span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" show-overflow-tooltip></el-table-column>
      <el-table-column prop="num" label="该类用户数量">
        <template #default="scope">
          <el-button type="text" @click="showUserList(scope.row.ID, scope.row.name)">{{ scope.row.num }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="启用状态" width="100" align="center">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!(scope.row.status == 1) ? 'red' : '']">
            {{ scope.row.status == 1 ? "启用" : "禁用" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="CreatedAt" label="创建日期" show-overflow-tooltip header-align="center"
        :formatter="dateRfcHMS"></el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit" @click="editRule(scope.row)">编辑
          </el-button>
          <el-button type="text" style="color: red;" @click="deleteRule(scope.row.ID)" icon="el-icon-delete">删除
          </el-button>
        </template>

      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
        :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog v-model="editVisible" :title="[form.code ? '编辑' : '添加'] + '用户等级'" @close="editVisible = false"
      :width="550">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <el-form-item prop="name" label="等级名称：">
          <el-input v-model="form.name" :disabled="actTitle=='编辑'" placeholder="请输入等级名称"></el-input>
        </el-form-item>
        <el-form-item prop="month" label="统计单位：">
          <el-select v-model="form.month" :disabled="actTitle=='编辑'" placeholder="请选择统计单位" size="large" style="width: 240px">
            <el-option v-for="item in monthInfo" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item prop="minQuantity" label="最低下单量：">
          <el-input-number v-model="form.minQuantity" :disabled="actTitle=='编辑'" :controls="false" placeholder="请输入最低下单量"></el-input-number>
        </el-form-item>
        <el-form-item prop="maxQuantity" label="最大下单量：">
          <el-input-number v-model="form.maxQuantity" :disabled="actTitle=='编辑'" :controls="false" placeholder="请输入最多下单量（不包含）"></el-input-number>
          <el-tag type="primary"><el-icon>
              <WarningFilled />
            </el-icon>区间内不包含最大下单量, 该区间不可以和其他区间重叠</el-tag>
        </el-form-item>
        <el-form-item label="等级描述：">
          <el-input type="textarea" v-model="form.desc" placeholder="请输入描述" style="height: 200px;"
            resize="none"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="是否启用：">
          <el-switch v-model="form.status"></el-switch>
        </el-form-item>
        <div style="text-align: right; margin-top: 10px">
          <el-button @click="editVisible = false">取消</el-button>
          <el-button type="primary" @click="saveEdit">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog :title="userNum" v-model="userVisible" width="30%">
      <el-table :data="userList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
        :cell-style="centerStyle">
        <el-table-column prop="ID" label="ID" width="55" align="center">
          <template #default="scope">
            <span>{{ scope.row.user.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="称呼" width="200" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.user.real_name || scope.row.user.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="手机号码" width="200" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.user.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="下单量" show-overflow-tooltip header-align="center"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="total, prev, pager, next" :current-page="rule_query.page"
          :page-size="rule_query.pageSize" :total="userPageTotal"
          @current-change="handleUserPageChange"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getActivityRulesList, createActivityRule, updateActivityRule, resetActivityDefault, getActivityRuleUsers,deleteActivityRule } from "../api/user_rules";
export default {
  name: "ActivityRules",
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        minQuantity: [{ required: true, message: '请输入最低下单量', trigger: 'blur' }],
        maxQuantity: [{ required: true, message: '请输入最高下单量', trigger: 'blur' }],
        month: [{ required: true, message: '请选择统计单位', trigger: 'change' }]
      },
      tableData: [{
        ID: 1
      }],
      pageTotal: 0,
      form: {
        id: 0,
        status: 1, //规则状态（1-启用，2-停用）
        name: '', //规则名称
        desc: '', //规则描述
        minQuantity: null, //最小数量
        maxQuantity: null //最大数量
      },
      actTitle: "新增", // 弹框标题
      editVisible: false, // 弹框开启状态
      userList: [],
      rule_query: {
        page: 1,
        pageSize: 10,
        activityRuleId: null
      },
      userPageTotal: 0,
      userNum: '用户列表（总0人）',
      userVisible: false,
      monthInfo: [
        { value: 99999, label: '不限时间' },
        { value: 1, label: '近1个月' },
        { value: 2, label: '近2个月' },
        { value: 3, label: '近3个月' },
        { value: 4, label: '近4个月' },
        { value: 6, label: '近半年' },
        { value: 12, label: '近1年' },
        { value: 24, label: '近2年' },
        { value: 36, label: '近3年' },
        { value: 48, label: '近4年' },
      ],
      monthMap: new Map(),
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
      this.getMonthMap()
    },

    getMonthMap() {
      this.monthInfo.forEach(item => {
        this.monthMap.set(item.value, item.label)
      })
    },
    dateRfcHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    },

    centerStyle() {
      return 'text-align:center'
    },
    getData() {
      // this.tableData = []
      getActivityRulesList(this.query).then(res => {
        this.tableData = res.data.list
        this.pageTotal = res.data.total
      })
    },


    // 触发搜索按钮
    // handleSearch() {
    //     this.getData()
    // },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
    // 用户列表分页导航
    handleUserPageChange(val) {
      this.rule_query.page = val
      this.getUserList(this.rule_query.activityRuleId)
    },

    // 添加弹框
    addRule() {
      this.form = {}
      this.actTitle = "新增"
      this.form.id = null
      this.editVisible = true
    },

    // 编辑弹框
    editRule(row) {
      this.actTitle = "编辑"
      this.form.id = row.ID
      this.form.name = row.name
      this.form.month = row.month
      this.form.desc = row.desc
      this.form.status = row.status == 1 ? true : false
      this.form.minQuantity = row.minQuantity
      this.form.maxQuantity = row.maxQuantity
      this.editVisible = true
    },

    showUserList(id, name) {
      this.userVisible = true
      this.getUserList(id)
      this.userTypeName = name
    },
    getUserList(id) {
      this.rule_query.activityRuleId = id
      getActivityRuleUsers(this.rule_query).then(res => {
        if (res.code === 0) {
          this.userList = res.data.list
          this.userNum = this.userTypeName + '（总' + res.data.total + '人）'
          this.userPageTotal = res.data.total
        }
      })
    },

    saveEdit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (!!this.form.id && this.form.id != 0) {
          this.form.status = this.form.status ? 1 : 2
          updateActivityRule(JSON.stringify(this.form)).then(res => {
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.editVisible = false
              this.getData()
            }
          })
        } else {
          this.form.status = this.form.status ? 1 : 2
          createActivityRule(JSON.stringify(this.form)).then(res => {
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.editVisible = false
              this.getData()
            }
          })
        }
      })
    },

    // 重置成默认规则
    resetDefault() {
      this.$confirm('确定重置为默认规则吗？重置后当前规则将全部被覆盖。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetActivityDefault().then(() => {
          this.$message.success('重置成功')
          this.getData()
        })
      })
    },

    // 删除活动
    deleteRule(id) {
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(() => {
        deleteActivityRule(JSON.stringify({ id })).then(res => {
          if (res) {
            this.$message.success('删除成功')
          }
          this.getData()
        })
      })
    }
  }
};
</script>
<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.mr10 {
  margin-right: 10px;
}

.el-input,
.el-input-number {
  width: 220px;
  margin-right: 10px;
}

.el-select {
  width: 220px;
}

.el-dialog__body .el-select,
.el-dialog__body .el-input,
.el-dialog__body .el-input-number,
.el-dialog__body .el-textarea {
  width: 80% !important;
  text-align: left;
}

.box {
  margin: 0 auto;
}

.box .el-input {
  width: 60%;
}

.rowstyle {
  width: 100%;
  margin: 0 auto;
  padding-left: 15%;
}

.el-row {
  margin-bottom: 10px;
}

.el-col {
  border-radius: 4px;

}

.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}

.grid-content {
  border-radius: 4px;
  min-height: 24px;
  text-align: center;
  line-height: 24px;
}

.tip {
  font-size: 12px;
  color: red;
}

.w350 {
  width: 350px;
}

.w250 {
  width: 250px;
}
</style>